var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { TerminalPayOptionComponent, TerminalPayOptionContext, TerminalPayProcessingContextProvider, TerminalPayProcessingModal, useTerminalPayOptionData, } from '@kareo/billing-system';
import CardDetailsContext from './CardDetailsContext';
export default function TerminalPayComponentBridge(_a) {
    var showProcessingModal = _a.showProcessingModal, setShowProcessingModal = _a.setShowProcessingModal, handleCreateTerminalTransaction = _a.handleCreateTerminalTransaction, handleCompleteTerminalTransaction = _a.handleCompleteTerminalTransaction, handleCreateHostedPayments = _a.handleCreateHostedPayments;
    var _b = useContext(CardDetailsContext), isProcessingTransaction = _b.isProcessingTransaction, setIsProcessingTransaction = _b.setIsProcessingTransaction, selectedTerminal = _b.selectedTerminal, setSelectedTerminal = _b.setSelectedTerminal, isUsingTerminalPayOption = _b.isUsingTerminalPayOption, setIsUsingTerminalPayOption = _b.setIsUsingTerminalPayOption, setError = _b.setError, saveCardState = _b.saveCardState, setSaveCardState = _b.setSaveCardState;
    var payOptionBaseData = useTerminalPayOptionData();
    var payOptionOverridableData = {
        isActive: isUsingTerminalPayOption,
        setIsActive: setIsUsingTerminalPayOption,
        selectedTerminal: selectedTerminal,
        setSelectedTerminal: setSelectedTerminal,
        onError: setError,
        saveCardState: saveCardState,
        setSaveCardState: setSaveCardState,
        disabled: isProcessingTransaction,
    };
    var terminals = payOptionBaseData.terminals, isLoaded = payOptionBaseData.isLoaded;
    var showTerminalOption = isLoaded && terminals.length > 0;
    return (React.createElement(TerminalPayProcessingContextProvider, { terminal: selectedTerminal, onError: function (err) {
            setError(err);
            if (err !== null) {
                setShowProcessingModal(false);
                setIsProcessingTransaction(false);
            }
        }, handleCreateTerminalTransaction: handleCreateTerminalTransaction, onComplete: handleCompleteTerminalTransaction, handleCreateHostedPayments: handleCreateHostedPayments }, showTerminalOption && (React.createElement(TerminalPayOptionContext.Provider, { value: __assign(__assign({}, payOptionBaseData), payOptionOverridableData) },
        React.createElement(TerminalPayOptionComponent, null),
        React.createElement(TerminalPayProcessingModal, { open: showProcessingModal })))));
}
